export default {
    googleWalletName: 'Google Wallet',

    googleWalletInfoBannerCheckMarkSimple: 'Enkel, rask og kontaktløs betaling',
    googleWalletInfoBannerCheckMarkShopping: 'Kan brukes i butikk og nett',
    googleWalletInfoBannerCheckMarkBothTypes: 'Både debet- og kredittkort kan brukes',

    googleWalletInstructionsHeader: 'Slik gjør du det',
    googleWalletInstructionStepsStep: 'Steg',
    googleWalletInstructionStepsPrivacyStep: 'Personvern',
    googleWalletInstructionStepsPartOneSubtitle: 'Last ned Google Wallet-appen, som er gratis.',
    googleWalletInstructionStepsPartTwoSubtitle: 'Følg veiledningen i Google Wallet appen og legg til kort.',
    googleWalletInstructionStepsPartThreeSubtitle: 'Bruk mobilen din i butikken for kontaktløs betaling.',
    googleWalletInstructionStepsPartFourSubtitle: 'Les våre retningslinjer for personvernet ditt.',

    googleWalletInstructionStepsPartOneStepOne: 'Åpne Google Play på en mobil, nettbrett eller smartklokke',
    googleWalletInstructionStepsPartOneStepTwo: 'Søk etter Google Wallet',
    googleWalletInstructionStepsPartOneStepThree: 'Last ned appen',

    googleWalletInstructionStepsPartTwoStepOne: 'Velg hvilket kort du vil bruke i mobilbanken',
    googleWalletInstructionStepsPartTwoStepTwo: 'Trykk på “Google Wallet” og velg “Legg til i Google Wallet”',
    googleWalletInstructionStepsPartTwoStepThree: 'Du kan alternativt legge til kort manuelt i Google Wallet-appen',

    googleWalletInstructionStepsPartThreeStepOne:
        'Når du er klar for å betale aktiverer du skjermen på mobil eller smartklokke',
    googleWalletInstructionStepsPartThreeStepTwo: 'Pass på at mobil eller smartklokke er nært betalingsterminalen',
    googleWalletInstructionStepsPartThreeStepThree: 'Når du ser en hake på skjermen har du betalt',

    googleWalletInstructionStepsPartFourStepOne:
        'Formålet med behandlingen er å gi deg mulighet til å legge inn kortet ditt i Google Pay direkte fra mobilbanken. Behandlingsansvarlig er banken. Vi behandler dine personopplysninger på bakgrunn av vilkårene (avtalen) som du godkjenner ved å ta i bruk denne tjenesten. For å gjennomføre denne behandlingen deler vi ditt navn, adresse, mobilnummer, e-post og de 4 siste sifrene i kortet til Google som oppbevarer de opplysningene så lenge du har Google Pay.',
    googleWalletInstructionStepsPartFourStepTwo: 'Mer informasjon om håndering av personvern finner du her:',
    googleWalletInstructionStepsPartFourStepThree: 'Personvernerklæringen',

    googleWalletGetGoing: 'Kom i gang',
    googleWalletGetGoingCardAlreadyRegistered: 'Dette kortet er klart til å brukes med Google Wallet',
    googleWalletGetGoingCardTokenizationUnknown: 'Dette kortet har ukjent status i Google Wallet',
    googleWalletGooglePayCardTokenizationUnknown: 'Dette kortet har ukjent status i Google Pay',
    googleWalletGetGoingCardNotEligible: 'Dette kortet kan ikke benyttes med Google Wallet',

    // Tokenization errors
    googleWalletGetGoingTokenizationErrorAlreadyExists: 'Dette kortet er allerede i Google Wallet, sjekk status der',
    googleWalletGetGoingTokenizationErrorOperation: 'Google Wallet er utilgjengelig for øyeblikket',
    googleWalletGetGoingTokenizationErrorNotActivatedOrInstalled:
        'Google Wallet er ikke installert eller ikke aktivert. Følg instruksjonene under.',
    googleWalletGetGoingTokenizationErrorNotDefault: 'Vennligst sett Google Wallet som standard lommebok',
    googleWalletGetGoingTokenizationErrorTokenNotFound: 'Fikk ikke hentet Google Wallet-info på dette kortet',

    // Wallet info errors
    googleWalletWalletInfoErrorCheckFailed: 'Fikk ikke hentet Google Wallet-info på dette kortet',
    googleWalletWalletInfoErrorNoActiveWallet:
        'Google Wallet er ikke installert eller ikke aktivert. Følg instruksjonene under.',
    googleWalletWalletInfoErrorNoDefaultWallet: 'Vennligst sett Google Wallet som standard lommebok',

    googleWalletGetGoingFetchError: 'Fikk ikke hentet Google Wallet-info på dette kortet',
    googleWalletOnlyAvailableOnAndroid: 'Kun tilgjengelig for Android',

    googleWalletAddToGooglePayHeader: 'Legg til i Google Wallet',
    googleWalletAddToGooglePayDescription: 'Legg kortet ditt til i Google Pay for rask og sikker betaling.',
    googleWalletAlreadyAddedGooglePayPart1: 'Lagt til i',
    googleWalletAlreadyAddedGooglePayPart2: 'Pay',
    googleWalletNotAvailable: 'Google Wallet er ikke tilgjengelig',
    googleWalletOPCError: 'Fikk ikke hentet kort detaljer for GPay',
    googleWalletNotCardOwnerError: 'Du eier ikke kortet, kan ikke legge kortet i Google Pay',
    googleWalletTemporaryUnavailable: 'Google Wallet er midlertidig utilgjengelig',

    googleWalletAddPermissionToGooglePayHeader: 'Tillatelse',
    googleWalletConfirmAddPermissionToGooglePayHeader: 'Bekreft',
    googleWalletConfirmAddPermissionToGooglePayIConfirm: 'Jeg bekrefter at',
    googleWalletConfirmAddPermissionToGooglePayIsAdded: 'legges til i Google Wallet på denne enheten.',
    googleWalletConfirmAddPermissionToGooglePayPermissionConfirmed: 'Tillatelse er gitt til kortet',
    googleWalletConfirmAddPermissionToGooglePayRedirectToEnrollment: 'Sender deg videre til Google Wallet...',
    googleWalletConfirmAddPermissionToGooglePayNativeWalletInfoUnavailable:
        'Noe gikk galt, dobbeltsjekk at telefonen tillater Google Wallet',
    googleWalletConfirmAddPermissionToGooglePayIsNotDefaultWallet: 'Vennligst sett Google Wallet som standard lommebok',
    googleWalletConfirmAddPermissionToGooglePaySigningCancelledError: 'Signering ikke fullført!',
    googleWalletConfirmAddPermissionToGooglePayError: 'Noe gikk galt!',

    googleWalletPushProvisionError: 'Noe gikk galt!',
    googleWalletPushProvisionCancelled: 'Vi ble avbrutt',
    googleWalletPushProvisionSuccess: 'Kortet er lagt til',
    googleWalletPushProvisionSuccessDescription: 'Kortet {} er lagt til i Google Wallet',
    googleWalletRedirectToGoogleWalletInfoPage: 'Sender deg tilbake...',

    googleWalletProcessStartInformation:
        'For å starte prosessen må dette bekreftes og godkjennes via BankID eller biometri.',

    googleWalletErrorTitle: 'Legge til Google Wallet er ikke tilgjengelig akkurat nå',
    googleWalletErrorDescription: 'Kontakt banken for mer informasjon.',

    googleWalletHighAssuranceMissingTitle: 'Digital lommebok',
    googleWalletHighAssuranceMissingText:
        'Vi er nødt til å forsikre oss om at ingen forsøker å utgi seg for å være deg. Gjennom en enkel bildeverifisering får du tilgang til å legge til kortet ditt i en digital lommebok.',
    googleWalletStepUpProceed: 'Kom i gang',
};
